/* global setTimeout */

let _$rootScope;
let _$cookies;
const _interval = 1000;
const _maxRetries = 120;

export default class GeneratedDocumentWatcher {
  constructor($rootScope, $cookies) {
    _$rootScope = $rootScope;
    _$cookies = $cookies;
    this.cookieName = null;
  }

  setDocumentPending(assessmentId) {
    this.cookieName = _getName(assessmentId);
    _$cookies.put(this.cookieName, 'waiting', { path: '/' });
    setTimeout(
      () => { this.checkDocumentComplete(_maxRetries); },
      _interval
    );
    return this.cookieName;
  }

  checkDocumentComplete(retryCount) {
    if (retryCount < 1) {
      return false;
    }
    const cookie = _$cookies.get(this.cookieName);
    if (!cookie || cookie === 'complete') {
      if (cookie === 'complete') {
        _$cookies.remove(this.cookieName, { path: '/' });
      }
      _$rootScope.$broadcast('refreshECATActiveAssessment');
      return true;
    }
    return setTimeout(
      () => { this.checkDocumentComplete(retryCount - 1); },
      _interval
    );
  }

  setDocumentComplete() {
    _$cookies.put(this.cookieName, 'complete', { path: '/' });
  }
}

function _getName(assessmentId) {
  const timestamp = new Date().toISOString().replace(/[:.-]/g, '');
  return `ECATDownloadDocument_${assessmentId}_${timestamp}`;
}
